import { atom } from "recoil"
export const acceptMatchingTermState = atom<boolean>({
  key: "atoms/matching/acceptMatchingTermStart",
  default: true,
})
